import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';

import Page from '../models/Page';

import FixedRight from './FixedRight';

import styles from './TopicHeader.module.scss';

const TopicHeader = ({page}) => (
  <header>
    {
      page.thumbnail
        ? <Img className={styles.image} fluid={page.thumbnail.fluid} alt={page.thumbnail.alt} />
        : null
    }

    <FixedRight bg="purple">
      <img alt={page.title} className={styles.icon}
        src={require(`../images/platform/${page.slug}.svg`)} />
      <h2 className={styles.title}>{page.title}</h2>
      <p>{page.excerpt}</p>
    </FixedRight>
  </header>
);

TopicHeader.propTypes = {
  page: PropTypes.instanceOf(Page),
};

export default TopicHeader;
